// extracted by mini-css-extract-plugin
export default {"markdownContainer":"markdown_markdownContainer__APBfb"};